import { useCallback, useState } from 'react';

export function useLocalStorage(name: string): [string | null, (value: string | null) => void] {
  const [value, setValue] = useState(localStorage.getItem(name));

  const changeValue = useCallback(
    (value: string | null) => {
      setValue(value);
      if (!value) {
        localStorage.removeItem(name);
      } else {
        localStorage.setItem(name, value);
      }
    },
    [name]
  );

  return [value, changeValue];
}
